import { WebsiteSessionData } from "$lib/api/generated/cta-services"

/**
 * Maps from the campaign data type to the website session data type
 * @param type The campaign data type
 * @returns The website session data type
 */
export const fromCampaignDataTypesToWebsiteSessionDataTypes = (type?: 'direct' | 'adv' | 'organic'): WebsiteSessionData.type | undefined => {
    return type == 'adv' ? WebsiteSessionData.type.ADV : type == 'direct' ? WebsiteSessionData.type.DIRECT : type == 'organic' ? WebsiteSessionData.type.ORGANIC : undefined
}